/**
 * Ensures that the header navigation sticks to the top
 * of the browser when a user scrolls.
 *
 * @return {void}
 */
export default function stickyHeader () {
	const headerElement = document.querySelector( '.header' );
	const containerElement = document.querySelector( '#container' );

	let ignoreScroll = false;

	if ( ! headerElement || ! containerElement ) {
		return;
	}

	const aboveNavAdContainer = document.querySelector( '#leaderboard' );

	const unlockScroll = () => {
		ignoreScroll = false;
	};

	// Use actual height of the leaderboard container if present.
	const offsetHeight = () => ( aboveNavAdContainer && window.innerWidth >= 1024 ) ? aboveNavAdContainer.offsetHeight + 90 : 0;

	const handleScroll = () => {
		if ( ignoreScroll ) {
			return;
		}

		const isAtTop = window.scrollY <= offsetHeight();

		if ( isAtTop ) {
			document.body.classList.remove( 'body--header-sticky' );
			headerElement.classList.remove( 'header--is-sticky' );
		} else {
			document.body.classList.add( 'body--header-sticky' );
			headerElement.classList.add( 'header--is-sticky' );
		}

		headerElement.classList.remove( 'header--mobile-is-open' );
		document.body.classList.remove( 'body--mobile-menu-is-open' );
	};

	window.addEventListener( 'scroll', handleScroll, { passive: true } );
	window.addEventListener( 'resize', handleScroll, { passive: true } );

	/**
	 * Listen for the custom event dispatched by the hamburger menu
	 * to ignore scroll events for a short period after the menu is opened
	 * to prevent the menu from closing immediately.
	 */
	window.addEventListener( 'newscientist-menu-open', () => {
		ignoreScroll = true;
		setTimeout( unlockScroll, 300 );
	} );
}
